import { FaTimes } from "react-icons/fa";

import { format, parseISO } from "date-fns";

const Task = ({ task, onDeleteTask, onToggleReminder }) => {
    const toggleReminderBorder = () => {
        let classes = "task";
        if (task.reminder) {
            classes += " reminder";
        }

        return classes;
    };

    function formatDate(date) {
        const parsedDate = parseISO(date);
        const formatted = format(parsedDate, "dd/MM/yyyy");

        // var prnDt = date.toLocaleTimeString(undefined, options);
        return formatted;
    }

    return (
        <div
            className={toggleReminderBorder()}
            onDoubleClick={() => onToggleReminder(task.id)}
        >
            <h3>{task.text}</h3>
            <div>
                <p>{formatDate(task.day)}</p>
                <FaTimes onClick={() => onDeleteTask(task.id)} />
            </div>
        </div>
    );
};

export default Task;
